export default "__VITE_ASSET__BAOGYTFQ__"